import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProviderModelsView } from '@modules/ai/common/forms/common/provider-models';
import RingFieldsList from '@common/form/ring-fields-list';
import { InformationBanner } from '@common/information-banner/information-banner';
import NavigationLink from '@common/navigation/navigation-link';
import { ExternalLinks } from '@common/constants/constants';
import styles from './mellum-ai-provider-form.css';
const columns = [
    { id: 'id', title: 'ID' },
    { title: 'Model URL', id: 'url', maxWidth: 308 }
];
export function MellumAiProviderForm({ provider: { models } }) {
    return (_jsxs(RingFieldsList, { children: [_jsx(InformationBanner, { variant: "neutral", className: styles.mellumBanner, children: _jsxs("span", { children: ["JetBrains Mellum models extend the capabilities of a custom AI provider, improving code completion for various programming languages.", ' ', _jsx(NavigationLink, { href: ExternalLinks.JB_MELLUM_INFO, target: "_blank", children: "Learn more" })] }) }), _jsx(ProviderModelsView, { columns: columns, models: models })] }));
}
